const darkTheme = {
    palette: {
        primary: {
            main: '#00FFB3',
            light: '#3FFFB3',
            dark: '#00DBAF',
            contrastText: '#000000',
        },
        secondary: {
            main: '#0E4D51',
            light: '#399694',
            dark: '#0A3D45',
            contrastText: '#ffffff',
        },
        error: {
            main: '#FF3564',
            light: '#FF677C',
            dark: '#DB2662',
            contrastText: '#000000',
        },
        warning: {
            main: '#FF9E16',
            light: '#FFBD50',
            dark: '#DB7E10',
            contrastText: '#000000',
        },
        info: {
            main: '#286CFF',
            light: '#5D95FF',
            dark: '#1D53DB',
            contrastText: '#000000',
        },
        success: {
            main: '#84EF6A',
            light: '#4FE53B',
            dark: '#30C42B',
            contrastText: '#000000',
        },
        background: {
            paper: '#07272b',
            default: '#00151C',
        },
    },
    shape: {
        borderRadius: 10,
    },
    typography: {
        fontFamily: '"Rubik", sans-serif',
    },
};

export default darkTheme;
